import S from './AllAnimalls.module.css';
import D from '../images/sensor.svg'
import { Link } from 'react-router-dom';
import InfoIcon from '@mui/icons-material/Info';
import { useDispatch, useSelector } from 'react-redux';
import { useRef, useState } from 'react';
import { useEffect } from 'react';
import { loginSuccessAllSens } from '../redux/slices/allSensorSlice';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import G from './ListDam.module.css'
import { useGlobalContext } from '../Components/Context';
import AddSensor from '../Components/AddNewsSensor';
import Filter5Icon from '@mui/icons-material/Filter5';
import DangerousIcon from '@mui/icons-material/Dangerous';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ReplayIcon from '@mui/icons-material/Replay';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import SplitscreenIcon from '@mui/icons-material/Splitscreen';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import NotificationsPausedIcon from '@mui/icons-material/NotificationsPaused';
import GrassIcon from '@mui/icons-material/Grass';
import { Battery0Bar, DateRange, SensorOccupiedOutlined, SensorsTwoTone } from '@mui/icons-material';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import apiService from '../api/ApiService';
import MoveCard from '../Components/MoveCard';
import SensorList from '../Components/cardThemes/SensorList';
import ReportIcon from '@mui/icons-material/Report';
import FemaleIcon from '@mui/icons-material/Female';
import Stand from '../images/stand.svg'

import {   Sell, Sensors } from '@mui/icons-material'
import LastPacketList from '../Components/cardThemes/LastPacketList';
import { timespanToDhm } from '../Components/cardThemes/LastPacketListCard';
import { Pagination } from '@mui/material';
import { paginateCount } from '../api/helper';
import EmptyReturn from '../Components/EmptyReturn';
import SensorListComp from '../Components/DeviceList/SensorList';
const moment=require('moment-jalaali');
const a=[
  {comp:'لیست سنسور ها'},{comp:'آخرین وضعیت سنسور'}
]


const AllSensors=()=>{
  const ref=useRef()
  const [page,setPage]=useState(0)
  const [total,setTotal]=useState(1)
  const [cursorPosition, setCursorPosition] = useState({x:0,y:0});
  const [iindex,setIndex]=useState(null)
  const {currentSfarm}=useSelector(state=>state.p.sFarm);
  const {currentAdmin,currentTheme}=useSelector(state=>state.p.admin);
  const [Value,setValue]=useState(0);
  const [sensorLastPacketList,setSensorPacketList]=useState([])
  const {currentSensors}=useSelector(state=>state.sensors)
  const {openModalls,isOpenModal}=useGlobalContext();
  const dispatch=useDispatch();
  const handleMouseEnter = (event) => {
      let currentTargetRect = event.currentTarget.getBoundingClientRect();
       
      let topTableFar=document.querySelector('.opSh')
      let fars=topTableFar.getBoundingClientRect().top

    setCursorPosition({
      y: currentTargetRect.top-fars,
      x: event.clientX - currentTargetRect.left-300,
    });
  };
 const handleMouseOut=()=>{
  setIndex(null)
 }

  const getLast=async()=>{
    const res2=await apiService.getSensorsPacketList(currentAdmin.id)
    setSensorPacketList(res2.data)

  }
  const handlePage = (event, value) => {
    setPage(value);
  };
  useEffect(()=>{
    getLast()
  },[])
    return <>
    <div className={S.AllAnimalssCon}>
   <div style={{display:'flex',justifyContent:'space-between',width:'100%',alignItems:'center'}}>
     <div className={S.AllAnimalssTitleCon}>
        <img className={S.AllAnimalssIconimgTit} src={D}/>
        <h2>لیست سنسور ها</h2>
        </div>
          <div onClick={()=>{openModalls()}} data-title='افزودن سنسور جدید' className={`${S.CreateNewFarmBtn}`}>
                <AddCircleOutlineIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
   </div>
   <div className={G.TabForAllAnnimbtnLICon}>
            {a.map((item,index)=>{
              return <div key={index} className={`${G.jobbtnLItab} ${index === Value && G.ActiveLITab}`} onClick={()=>setValue(index)} >{item.comp}</div>
              

            })}
          </div>
        <hr style={{marginTop:'-3px'}}/>
        <div className={G.TabForAllAnnimLICon}>
          
          { Value===0&&<SensorListComp Value={Value}/>}
            {

            !currentTheme&&Value===1&&<div className={G.AnimContentLI} data-aos='fade'>
              {sensorLastPacketList?.length?<table className='opSh'>
                <thead>
                <tr>
                <th>
                    <div className='LogoFormT'><div><span>
                <SplitscreenIcon/>
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
                <SensorsTwoTone/>
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
                <SensorsTwoTone/>
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
                <DangerousIcon/>
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
                <ReplayIcon/>
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
                <DeviceThermostatIcon/>
                </span>
                    </div></div>
                    </th>
                    
                    <th>
                    <div className='LogoFormT'><div><span>
                <WaterDropIcon/>
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
                <TrendingUpIcon/>
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
                <StackedLineChartIcon/>
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
                <GrassIcon/>
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
            <img style={{width:'20px',height:'20px'}}  src={Stand} width={20} height={20}/> 
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
                <NotificationsPausedIcon/>
                </span>
                    </div></div>
                    </th>
                    <th>
                    <div className='LogoFormT'><div><span>
                <GrassIcon/>
                </span>
                    </div></div>
                    </th>
                    

                  </tr>
                  <tr>
                    <th>
                      ردیف
                    </th>
                    <th>
                      فاصله دریافت آخرین پکت  
                    </th>
                    <th>
                        بازه دریافت پکت ها
                    </th>
                    <th>
                          کد سنسور
                    </th>
                    <th>
                          گردنبند 
                    </th>
                    <th>
                      پکت لاست 
                    </th>
                    <th>
                      پکت تکراری 
                    </th>
                    
                    <th>
                      میانگین دما
                    </th>
                    <th>
                      میانگین رطوبت
                    </th>
                    <th>
                      میانگین فعالیت
                    </th>
                    <th>
                      میانگین استرس
                    </th>
                    <th>
                      میانگین جویدن
                    </th>
                    <th>
                      میانگین ایستادن
                    </th>
                    <th>
                      میانگین خواب
                    </th>
                    <th>
                      میانگین نشخوار
                    </th>

                  </tr>
                </thead>
                <tbody>
                  
                  {
                    sensorLastPacketList?.map((item,index)=>{
                      return <tr ref={ref} key={index} onMouseOver={()=>{setIndex(index)}}  onMouseMove={handleMouseEnter} onMouseLeave={handleMouseOut}>
                      <td>
                        {index+1}
                      </td>
                      <td>
                        {timespanToDhm(item?.lastLogUntilNowTime)}
                      </td>
                      <td>
                        {timespanToDhm(item?.differenceLogTime)}
                      </td>
                      <td>
                        {item?.deviceCode}
                      </td>
                      <td>
                        {item?.necklaceNumber}
                      </td>
                      <td>
                        {item?.lostPacket}
                      </td>
                      <td>
                        {item?.duplicatePacket}
                      </td>
                      <td>
                        {Math.floor(item?.temperature)}
                      </td>
                      <td>
                        {Math.floor(item?.humidity)}
                      </td>
                      <td>
                        {item?.activity}
                      </td>
                      <td>
                        {item?.unrest}
                      </td>
                      <td>
                        {item?.chewing}
                      </td>
                      <td>
                        {item?.standing}
                      </td>
                      <td>
                        {item?.sleeping}
                      </td>
                      <td>
                        {item?.rumination}
                      </td>
                      
                      {iindex===index&&cursorPosition&&<td
          style={{
            position: 'absolute',
            transition:'0.2s ease',
            transform:`translate(${cursorPosition.x+333}px , ${cursorPosition.y-((index)*ref.current.clientHeight)-(index*2)-80}px)`,
            zIndex:22,
            
            
          }}><MoveCard data={item?.lastSensorLog}/></td>}
                    </tr>
                   
                   
                    })
                  }
                  
                </tbody>
              </table>:<EmptyReturn/>}
              
              </div>
            }
            {
                currentTheme&&Value===1&&<LastPacketList data={sensorLastPacketList}/>
              }
          </div>
        
            {isOpenModal&&<AddSensor/>}
    </div>
    </>
}
export default AllSensors
